import { render, staticRenderFns } from "./FqaDictList.vue?vue&type=template&id=726dc3a3&scoped=true&"
import script from "./FqaDictList.vue?vue&type=script&lang=js&"
export * from "./FqaDictList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726dc3a3",
  null
  
)

export default component.exports